var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/video-courtesy.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-ce465924!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/video-courtesy.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/VideoCourtesy.vue
// module id = 1369
// module chunks = 1